import * as React from "react";
import SelectField, {OptionValue} from "../../components/SelectField";
import {CategoryTextDto, ModelyearDto} from "../../services/Client";

interface CategoryTextDropdownProps {
    /** Displayed when there's no option type selected. */
    placeholder?: string;

    /** Options available in the dropdown */
    categories: CategoryTextDto[];

    /** Current selected value */
    value?: string;

    /** Callback when an option type is selected or the select field is cleared. */
    onChange: (value: string) => void;

    /** The loaded modelyear */
    modelyear: ModelyearDto;
    id?: string;
}

/**
 * SerialSelection is a select field component enables the selection of
 * serials for OptionBasicDtos.
 */
const CategoryTextDropdown = (props: CategoryTextDropdownProps) => {

    function onChange(selectedValue?: OptionValue, selectedIndex?: number) {
        if (selectedIndex !== undefined) {
            props.onChange(props.categories[selectedIndex].categoryCode);
        }
    }

    function renderKeys(selectedValue?: OptionValue, index?: number) {
        return index !== undefined ?
            props.categories[index].text.length > 0 ?
                props.categories[index].text
                : props.categories[index].categoryCode
            : '';
    }

    return (
        <SelectField
            id={props.id}
            optionStyle={{fontStyle: props.categories[0]
                && props.modelyear.objectId !== props.categories[0].modelyearId ? "italic" : "unset"}}
            searchable={true}
            clearable={false}
            value={props.value}
            dataSource={props.categories.map((item) => item.categoryCode)}
            rendererKey={renderKeys}
            onChange={onChange}
        />
    );
};
export default CategoryTextDropdown;



// WEBPACK FOOTER //
// ./src/views/BaseOptionsView/CategoryTextDropdown.tsx